// utils/messagerie.js
// Utilitaire partagé pour créer des conversations depuis n'importe quel composant

const STORAGE_KEY = 'darna-immo_messages';

export function ouvrirConversation(annonce) {
  try {
    const convs = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

    // Vérifie si une conv pour cette annonce existe déjà
    const existing = convs.find(c => c.annonceId === annonce.id);
    if (existing) return existing.id;

    // Sinon crée une nouvelle
    const newConv = {
      id: Date.now(),
      annonceId: annonce.id,
      contact: {
        nom: annonce.vendeurNom || 'Vendeur',
        initiales: (annonce.vendeurNom || 'V').substring(0, 2).toUpperCase(),
        annonce: annonce.titre,
      },
      messages: [],
      nonLus: 0,
    };

    const updated = [newConv, ...convs];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    return newConv.id;
  } catch {
    return null;
  }
}
